module.exports = __webpack_public_path__ + "img/logo-desktop.339d9c1.png";